export default __webpack_public_path__ + "static/media/slide4.485ba05a.jpg";